<template>
  <div class="topic-manager">
    <div class="row" style="margin-bottom: 20px;">
      <div class="col-xl-6">主管领导</div>
      <div class="col-xl-6" style="display: flex;justify-content: flex-end;align-items: center;">
        <Breadcrumb></Breadcrumb>
      </div>
    </div>
    <el-card>

      <template v-if="status==1">
        <el-table :header-cell-style="tableHeaderStyle" :data="list" border style="width: 100%" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column prop="realName" label="姓名" min-width="90" align="center"></el-table-column>
          <el-table-column prop="username" label="用户名" min-width="90" align="center"></el-table-column>
          <el-table-column prop="unitName" label="单位" min-width="100" align="center"></el-table-column>
        </el-table>
        <div class="btn-wrap">
          <el-button size="small" type="primary" class="mr-2" @click="addSubjectManager">添加</el-button>
          <el-popconfirm title="确定删除吗？" @confirm="delSubjectUser">
            <el-button type="danger" size="small" slot="reference">删除</el-button>
          </el-popconfirm>
        </div>
        <!-- 分页器 -->
        <div class="text-right mt-2">
          <el-pagination background layout="total, prev, pager, next" :page-size="query.pageSize" :total="total" @current-change="(e)=>{handlePageChange(e)}"></el-pagination>
        </div>
      </template>
      <template v-else>
        <div class="user-list">
          <el-page-header @back="toBack" content="设置主管领导"></el-page-header>
          <div class="mt-2 mb-2">
            <span>姓名：</span>
            <el-input v-model="userQuery.realName" placeholder="请输入" class="ml-3 mr-3" style="width: 180px" size="small"></el-input>
            <span>单位：</span>
            <el-input v-model="userQuery.unitName" placeholder="请输入" class="ml-3 mr-3" style="width: 180px" size="small"></el-input>
            <el-button type="success" size="small" @click="searchUser">查询</el-button>
          </div>
          <!-- 表格 -->
          <el-table :header-cell-style="tableHeaderStyle" :data="list" border style="width: 100%" @selection-change="userSelectionChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="realName" label="姓名" min-width="180" align="center"></el-table-column>
            <el-table-column prop="username" label="用户名" min-width="180" align="center"></el-table-column>
            <el-table-column prop="unitName" label="单位" min-width="180" align="center"></el-table-column>
          </el-table>
        </div>
        <div class="mt-2">
          <el-button type="primary" size="small" @click="addSubjectUser">确 定</el-button>
        </div>
        <div class="text-right mt-2">
          <el-pagination background layout="total, prev, pager, next" :page-size="userQuery.pageSize" :total="total" @current-change="(e)=>{handlePageChange2(e)}"></el-pagination>
        </div>
      </template>
    </el-card>
  </div>
</template>

<script>
import Breadcrumb from "@/views/backstage/components/Breadcrumb.vue";
import { getLeaderList, getUserList, updateRole } from "@/api/after/systemManagement";
export default {
  components: { Breadcrumb, },
  data() {
    return {
      tableHeaderStyle: { backgroundColor: "#3083c5", color: "#fff" },
      status: 1,
      multipleSelection: [],
      userMultipleSelection: [],
      list: [],
      total: 0,
      query: { pageNumber: 1, pageSize: 10, },
      userQuery: {
        roleId: '9',
        unitName: this.unitName,
        realName: this.realName,
        pageSize: 10,
        pageNumber: 1,
      }
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    // 获取数据列表
    getData() {
      getLeaderList(this.query).then((res) => {
        if (res.code == 200) {
          this.total = res.data.total;
          this.list = res.data.records;
        } else {
          this.list = [];
          this.$message.error(res.data);
        }
      });
    },
    // 多选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //删除
    delSubjectUser() {
      if (!this.multipleSelection.length) return;
      let data = [];
      data = this.multipleSelection.map((item) => {
        let arr = { id: item.id, roleId: item.roleId, };
        arr.roleId = arr.roleId.split(",");
        arr.roleId.splice(arr.roleId.indexOf("9"), 1);
        arr.roleId = arr.roleId.join(",");
        return arr;
      });
      this.updateRole(data, "del");
    },
    // 获取用户列表
    getUserList() {
      getUserList(this.userQuery).then((res) => {
        if (res.code == 200) {
          this.total = res.data.total;
          this.list = res.data.records;
        } else {
          this.list = [];
          this.$message.error(res.data);
        }
      });
    },
    //搜索
    searchUser() {
      this.userQuery.pageNumber = 1;
      this.getUserList();
    },
    // 添加
    addSubjectManager() {
      this.userQuery.pageNumber = 1;
      this.userQuery.unitName = '';
      this.userQuery.realName = '';
      this.getUserList();
      this.status = 2;
    },
    // 返回
    toBack() {
      this.query.pageNumber = 1;
      this.getData();
      this.status = 1;
    },
    // 用户多选
    userSelectionChange(val) {
      this.userMultipleSelection = val;
    },
    //添加
    addSubjectUser() {
      if (!this.userMultipleSelection.length) return;
      let data = [];
      data = this.userMultipleSelection.map((item) => {
        let arr = { id: item.id, roleId: item.roleId, };
        arr.roleId = arr.roleId ? arr.roleId.split(",") : [];
        arr.roleId.push("9");
        arr.roleId = arr.roleId.join(",");
        return arr;
      });
      console.log(data);
      this.updateRole(data, "add");
    },
    // 修改角色id
    updateRole(query, type) {
      updateRole(query).then((res) => {
        if (res.code == 200) {
          this.$message.success(`${type == "del" ? '删除' : '添加'}成功`);
          this.toBack();
          this.multipleSelection = [];
          this.userMultipleSelection = [];
        } else {
          this.$message.error(res.data);
        }
      });
    },
    // 分页导航
    handlePageChange(val) {
      this.query.pageNumber = val;
      this.getData();
    },
    // 用户列表分页导航
    handlePageChange2(val) {
      this.userQuery.pageNumber = val;
      this.getUserList();
    },
  },
};
</script>

<style scoped lang="scss">
.btn-wrap {
  margin-top: 20px;
}
</style>
